import React, {useState} from "react";

import './qualification.css'

const Qualification = () => {

    const experience = [
        {
            id: 1,
            company: 'Freelance',
            position: 'UI/UX designer/ Graphic designer',
            location: 'Ukraine, Remote',
            dataStart: '11.2021',
            dataEnd: 'Present',
        },
        {
            id: 2,
            company: 'Junior UI/UX designer/ Graphic designer',
            position: 'Maxim studio',
            location: 'Ukraine, Remote',
            dataStart: '2021',
            dataEnd: '2022',
        },
        {
            id: 3,
            company: 'TRT express/ TRT international/ TRT shopping',
            position: 'UI/UX designer/ Graphic designer',
            location: 'Ukraine, Remote',
            dataStart: '2023',
            dataEnd: '2023',
        },
        {
            id: 4,
            company: 'Brilliant studio',
            position: 'UI/UX designer',
            location: 'Ukraine, Remote',
            dataStart: '2023',
            dataEnd: '2023',
        },
    ];
    const education = [
        {
            id: 1,
            place: 'Polytechnic College',
            name: 'Junior Bachelor of Accounting and Taxation',
            location: 'Ukraine, Nikolaev',
            dataStart: '2020',
            dataEnd: '2022',
        },
        {
            id: 2,
            place: 'Prog.academy',
            name: 'UI/UX designer course',
            location: 'Ukraine, Remote',
            dataStart: '2021',
            dataEnd: '2021',
        }
    ];

    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    }

    return (
        <section className="qualification section" id='qualification'>
            <h2 className="section__title">
                Qualification
            </h2>

            <span className="section__subtitle">
                My personal journey
            </span>
            <div className="container qualification__container">
                <div className="qualification__tabs">
                    <div className={
                        toggleState === 1
                            ? 'qualification__button qualification__active button--flex'
                            : 'qualification__button button--flex'
                    }
                         onClick={() => toggleTab(1)}>
                        <i className="qualification__icon uil uil-briefcase-alt"></i>
                        {' '}
                        Experience
                    </div>
                    <div className={
                        toggleState === 2
                            ? 'qualification__button qualification__active button--flex'
                            : 'qualification__button button--flex'
                    }
                         onClick={() => toggleTab(2)}
                    >
                        <i className="qualification__icon uil uil-graduation-cap"></i>
                        {' '}
                        Education
                    </div>
                </div>

                <div className="qualification__sections">

                    <div className={toggleState === 1
                        ? 'qualification__content qualification__content-active'
                        : 'qualification__content'
                    }>
                        {experience.map(item => (
                            <div className="qualification__data" key={item.id}>
                                <div  className='qualification__data-info'>
                                    <h3 className="qualification__title">
                                        {item.position}
                                    </h3>

                                    <div className="qualification__company">
                                        {item.company}
                                    </div>

                                    <span className="qualification__subtitle">
                                        {item.location}
                                    </span>

                                    <div className="qualification__calendar">
                                        <i className="uil uil-calendar-alt"></i>
                                        {item.dataStart} - {item.dataEnd}
                                    </div>
                                </div>

                                <div>
                                    <span className="qualification__rounder">

                                    </span>
                                    <span className="qualification__line">

                                    </span>
                                </div>

                                <div className='qualification__data-space'></div>
                            </div>
                        ))}

                    </div>

                    <div className={toggleState === 2
                        ? 'qualification__content qualification__content-active'
                        : 'qualification__content'
                    }>
                        {education.map(item => (
                            <div className="qualification__data" key={item.id}>
                                <div className='qualification__data-info'>
                                    <h3 className="qualification__title">
                                        {item.name}
                                    </h3>
                                    <div className="qualification__place">
                                        {item.place}
                                    </div>

                                    <span className="qualification__subtitle">
                                            {item.location}
                                        </span>

                                    <div className="qualification__calendar">
                                        <i className="uil uil-calendar-alt"></i>
                                        {item.dataStart} - {item.dataEnd}
                                    </div>
                                </div>

                                <div>
                                    <span className="qualification__rounder">

                                    </span>
                                    <span className="qualification__line">

                                    </span>
                                </div>

                                <div className='qualification__data-space'></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Qualification;